import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService } from 'webcommon/core-ui';
import { FcGenericItemModalBaseComponent } from '../../generic/fc-generic-item-modal-base.component';
import { FcListValidationService } from '../../generic/fc-list-validation/fc-list-validation.service';
import { FcMessageSubTypeListItemDto, FcModifyMessageSubTypeTypeListItemDto, Guid } from 'webcommon/shared';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'fc-subtype-list-modal',
  styleUrls: ['./fc-subtype-list-modal.component.less'],
  templateUrl: './fc-subtype-list-modal.component.html',
})
export class FcSubTypeListModalComponent extends FcGenericItemModalBaseComponent implements OnInit {
  public override baseId = 'fc-subtye-type';
  public listItem: FcMessageSubTypeListItemDto;

  // Form Controls
  public externalIdControl: FormControl = new FormControl<string>('');
  public nameControl: FormControl = new FormControl<string>('');
  public MessageTypeUidControl: FormControl = new FormControl<string>('');
  public notesControl: FormControl = new FormControl<string>('');
  public inactiveControl: FormControl = new FormControl<boolean>(false);
  public userDefinedControl: FormControl = new FormControl<boolean>(true);

  // Form Group
  public form = new FormGroup({
    externalId: this.externalIdControl,
    name: this.nameControl,
    MessageTypeUid: this.MessageTypeUidControl,
    notes: this.notesControl,
    inactive: this.inactiveControl,
    userDefined: this.userDefinedControl,
  });

  public override ngOnInit(): void {
    super.ngOnInit();
    this.loadListItem({
      ExternalID: {
        MaxLength: 25,
      },
      Name: {
        IsRequired: true,
        MaxLength: 50,
      },
      MessageTypeUid: {
        MaxLength: 50,
      },
      Notes: {
        MaxLength: 65535,
      },
    });
  }

  onMessageTypeSelected(selectedValue: any) {
    if (selectedValue && selectedValue.length > 0) {
      this.MessageTypeUidControl.setValue(selectedValue[0]?.MessageTypeUid);
    } else {
      this.MessageTypeUidControl.setValue(null);
    }
  }

  public setForm(): void {
    const userDefinedValue = this.listItem?.UserDefined ?? true;

    // External Id Control
    this.externalIdControl.setValidators(this.fcListValidation.getValidators('ExternalID'));
    this.externalIdControl.setValue(this.listItem?.ExternalID);

    // Name Control
    const isNameControlDisabled = !userDefinedValue;
    if (isNameControlDisabled) {
      this.nameControl.disable();
    }
    this.nameControl.setValidators(this.fcListValidation.getValidators('Name'));
    this.nameControl.setValue(this.listItem?.Name);

    // MessageTypeUid Control
    this.MessageTypeUidControl.setValidators(this.fcListValidation.getValidators('MessageTypeUid'));
    this.MessageTypeUidControl.setValue(this.listItem?.MessageTypeUid);

    // Notes Control
    this.notesControl.setValidators(this.fcListValidation.getValidators('Notes'));
    this.notesControl.setValue(this.listItem?.Notes);

    // Inactive Control
    this.inactiveControl.setValue(this.listItem?.Inactive || false);

    // User Defined Control
    this.userDefinedControl.disable();
    this.userDefinedControl.setValue(userDefinedValue);

    this.validateForm();
  }

  public override save(): void {
    const values = this.form.getRawValue();

    const modifyItemDto: FcModifyMessageSubTypeTypeListItemDto = {
      ExternalID: this.externalIdControl.value,
      Name: values.name,
      MessageTypeUid:  values.MessageTypeUid ? values.MessageTypeUid :Guid.empty(),
      Notes: values.notes,
      Inactive: values.inactive,
      UserDefined: values.userDefined,
    };
    super.save<FcModifyMessageSubTypeTypeListItemDto>(modifyItemDto);
  }

}
